// @flow
import React from "react";
// $FlowFixMe
import { Route, Routes, type Location } from "react-router-dom";
import { get } from "lodash";
import type { Device, Product, MapFeatureToggles } from "@tvg/conf/src/types";
import type { UnaryFn } from "@tvg/types/Functional";

import {
  HomePageLoadable,
  TutorialsPageLoadable,
  ProgramPageLoadable,
  PicksPageLoadable,
  LivePageLoadable,
  MorePageLoadable,
  WagerRewardsLoadable,
  EmailUnsubscribePageLoadable,
  RedirectEngineLoadable,
  EmailSubscribePageLoadable,
  TracksPageLoadable,
  RacetracksPageLoadable
} from "./Loadables";
import AppRoutes from "./Routes";
import RedirectPage from "./components/RedirectPage";
import type { TransitionState, RouteType } from "../types";

const ComponentMap = {
  home: HomePageLoadable,
  live: LivePageLoadable,
  programPageNoTrackInfo: ProgramPageLoadable,
  programPage: ProgramPageLoadable,
  programPageOld: ProgramPageLoadable,
  liveProgramPage: ProgramPageLoadable,
  liveProgramPageOld: ProgramPageLoadable,
  programPageGreyhoundsWithoutName: ProgramPageLoadable,
  programPageGreyhounds: ProgramPageLoadable,
  programPageGreyhoundsOld: ProgramPageLoadable,
  tracksPage: TracksPageLoadable,
  tracksPageResults: TracksPageLoadable,
  tracksPageAllInfo: TracksPageLoadable,
  tracksPageTrackDetails: TracksPageLoadable,
  racetracks: RacetracksPageLoadable,
  picks: PicksPageLoadable,
  account: MorePageLoadable,
  wagerRewards: WagerRewardsLoadable,
  optedin: HomePageLoadable,
  tutorials: TutorialsPageLoadable,
  emailSubscribe: EmailSubscribePageLoadable,
  emailUnsubscribe: EmailUnsubscribePageLoadable,
  redirectEngine: RedirectEngineLoadable,
  redirect: RedirectPage,
  default: HomePageLoadable
};

const ComponentOverride = {
  liveProgramPage: {
    overrideLoadable: LivePageLoadable,
    toggle: "enableURPWatchFDTV"
  },
  liveProgramPageOld: {
    overrideLoadable: LivePageLoadable,
    toggle: "enableURPWatchFDTV"
  }
};

export const PageRoutes: UnaryFn<MapFeatureToggles, Array<RouteType>> = (
  toggles
) =>
  AppRoutes.filter((route) =>
    route.toggle ? toggles[route.toggle] : true
  ).map((route) => {
    const routeOverride = get(ComponentOverride, `${route.key}`);

    const componentToReturn =
      routeOverride && toggles[routeOverride.toggle]
        ? routeOverride.overrideLoadable
        : ComponentMap[route.key];

    return { ...route, component: componentToReturn };
  });

type Props = {
  location: Location,
  state: TransitionState,
  prevPath: string,
  isLogged: boolean,
  device: Device,
  product: Product,
  toggles: MapFeatureToggles,
  isBeta: boolean,
  isFixed: boolean
};

export default (props: Props) => (
  <Routes location={props.location}>
    {PageRoutes(props.toggles)
      .map(
        (Page: RouteType) =>
          // $FlowFixMe
          Page.component && (
            <Route
              key={Page.key}
              path={Page.path}
              exact={Page.exact}
              element={
                // $FlowFixMe
                <Page.component
                  transitionState={props.state}
                  prevPath={props.prevPath}
                  isLogged={props.isLogged}
                  device={props.device}
                  product={props.product}
                  isBeta={props.isBeta}
                  isFixed={props.isFixed}
                  featureToggles={props.toggles}
                />
              }
            />
          )
      )
      .filter(Boolean)}
  </Routes>
);
